import { ConnectedDashboard as Dashboard} from 'layouts/Dashboard';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { setKeycloak } from 'redux/keycloak/actions';
import Navbar from '../../components/Navbar';

interface IProps {
	keycloak: any
}

interface IConnectedProps {
	setKeycloak: (keycloak: any) => void,
}

const Home: React.FunctionComponent<IProps & IConnectedProps> = ({ keycloak,  setKeycloak }) => {
	setKeycloak(keycloak);
	return (
		<div>
			<Navbar keycloak={keycloak} />
			<Dashboard />
		</div>
	)
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setKeycloak: (keycloak: any) => dispatch(setKeycloak(keycloak)),
});

export default connect<{}, IConnectedProps, { keycloak: any }>(null, mapDispatchToProps)(Home);
